// Blog post exports for loading blog metadata and posts
// All blog content is now served from /public/blog/ directory

let metadataCache = null;

// Load metadata from public folder
const loadMetadata = async () => {
  if (metadataCache) return metadataCache;
  
  try {
    const response = await fetch('/blog/metadata.json');
    if (!response.ok) {
      throw new Error(`Failed to load metadata: ${response.status}`);
    }
    metadataCache = await response.json();
    return metadataCache;
  } catch (error) {
    console.error('Error loading blog metadata:', error);
    return { posts: [] };
  }
};

// Get all blog posts metadata
export const getAllPosts = async () => {
  const metadata = await loadMetadata();
  return metadata.posts.sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Get a specific post by slug
export const getPostBySlug = async (slug) => {
  const metadata = await loadMetadata();
  return metadata.posts.find(post => post.slug === slug);
};

// Get featured posts
export const getFeaturedPosts = async () => {
  const metadata = await loadMetadata();
  return metadata.posts.filter(post => post.featured);
};

// Get posts by tag
export const getPostsByTag = async (tag) => {
  const metadata = await loadMetadata();
  return metadata.posts.filter(post => post.tags && post.tags.includes(tag));
};